<div *ngIf="auth.currentUserSubject | async; then authenticated else guest">
</div>


<!-- User NOT logged in -->
<ng-template #guest>
    <div class="user-holder" *ngIf="!unika">
        <!-- <p>שלום, אורח<p> -->
        <!-- <p>Login to get started...</p> -->
        <!-- <div>
            {{ 'USER-ENTER-GOOGLE-ACCOUNT' | translate }}
        </div> -->
        <button class="btn btn-small fa fa-sign-in" (click)="auth.googleLogin()">
            <!-- <i class="fa fa-google"></i> -->
            {{ 'USER-LOGIN' | translate }}
        </button>
    </div>
    <div class="user-holder" *ngIf="unika">
        <!-- <p>שלום, אורח<p> -->
        <!-- <p>Login to get started...</p> -->
        <!-- <div>
            {{ 'USER-ENTER-GOOGLE-ACCOUNT' | translate }}
        </div> -->
        <!-- <button class="btn btn-small fa fa-sign-in" (click)="auth.googleLogin()">
            {{ 'USER-LOGIN' | translate }}
        </button> -->
        <a class="users-roles-triger" (click)="auth.googleLogin()"></a>
    </div>
</ng-template>


<!-- User logged in -->
<ng-template #authenticated>
    <div class="user-prof" *ngIf="auth.currentUserSubject | async as user">
        <h3>{{ 'USER-HELLOW' | translate }}, {{ user.displayName }}</h3>
        <div class="image-with-staus">
            <div class="image-holder" (click)="this.showRoles = !this.showRoles">
                <img [src]="user.photoURL" alt="user photo">
            </div>
            <span></span>
        </div>
        <div class="user-details-holder">
            <h3 *ngIf="!unika">{{ 'USER-HELLOW' | translate }}, {{ user.displayName }}</h3>
            <div class="title-holder" (click)="this.showRoles = !this.showRoles">
                <h3 *ngIf="unika">{{ user.displayName }}</h3>
            </div>
            <div class="roles" *ngIf="!unika">
                <div class="hide-details">
                    <button (click)="auth.signOut()" class="btn btn-small">{{ 'USER-LOG-OFF' | translate }}</button>
                </div>
                <!-- <div class="hide-details" *ngIf="user.roles.admin">
                    <button class="btn btn-small" [routerLink]="['/admin']">Admin</button>
                </div>
                <div class="hide-details" *ngIf="user.roles.editor">
                    <a class="btn btn-small" (click)="goToEditorView()" href="javascript:;">Editor</a>
                </div> -->
            </div>
            <a class="users-roles-triger" (click)="this.showRoles = !this.showRoles" [class.active]="this.showRoles"></a>
            <div @anim class="roles" *ngIf="unika && this.showRoles">
                <div class="hide-details">
                    <button (click)="auth.signOut()" class="btn btn-small">{{ 'USER-LOG-OFF' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
